import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/core/base.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { SessionService } from 'src/app/shared/services/session.service';
import { AddonListQueryFilter } from './addon-list-query-filter';
import { Addon } from '../models/addon';
import { Sort } from '@angular/material/sort';
import { AddonService } from '../services/addon.service';
import { AddonCreateModelComponent } from '../modals/addon/addon-create-model/addon-create-model.component';
import { MatDialog } from '@angular/material/dialog';
import { AddonEditModelComponent } from '../modals/addon/addon-edit-model/addon-edit-model.component';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';

@Component({
    selector: 'addon-list',
    templateUrl: './addon-list.component.html',
    styleUrl: './addon-list.component.scss',
    standalone: false
})
export class AddonListComponent extends BaseComponent implements OnInit{
  @Input() filter: AddonListQueryFilter = new AddonListQueryFilter();
  public updateFilterEvent = new EventEmitter<any>();
  public addons: Addon[] = [];

  constructor(sessionService: SessionService,
    stringHelpers: StringHelpers,
    private dialog: MatDialog,
    private addonService: AddonService) {
    super(sessionService, stringHelpers);
    this.displayedColumns = ['name', 'description', 'price', 'isActive', 'actions'];
  }

  ngOnInit(): void {
    this.getAddons();
  }

  getAddons(){
    this.isLoading = true;
    this.filter.organizationId = this.sessionService.getUser().organizationId;
    this.addonService.getAllByOrganization(this.filter).subscribe({
      next: (result: any) => {
        this.addons = result.results;
        this.filter.totalCount = result.totalCount;
        this.updateFilterEvent.emit(result.results);
      },
      error: (error) => {
        this.isLoading = false;
        console.error(error);
      },
      complete: () => this.isLoading = false
    });
  }

  updateIsAvailable(addon: Addon, event){
    this.isLoading = true;
    addon.isActive = event;
    addon.lastEditedBy = this.sessionService.getUserId();
    this.addonService.update(addon.id, addon).subscribe({
      next: () => {
        this.getAddons();
      },
      error: (error) => {
        this.isLoading = false;
        console.error(error);
      },
      complete: () => this.isLoading = false
    });
  }

  create(){
    const dialogRef = this.dialog.open(AddonCreateModelComponent, {
      width: 'auto',
      height: 'auto',
    });
        
    dialogRef.componentInstance.form.get('organizationId').setValue(this.sessionService.getUser().organizationId);

    dialogRef.afterClosed().subscribe(result => {
      if(result === 'save'){
        this.getAddons();
      }
    });
  }

  edit(addon: Addon){
    const dialogRef = this.dialog.open(AddonEditModelComponent, {
      width: 'auto',
      height: 'auto',
    });

    dialogRef.componentInstance.form.get('organizationId').setValue(this.sessionService.getUser().organizationId);
    dialogRef.componentInstance.form.get('name').setValue(addon.name);
    dialogRef.componentInstance.form.get('description').setValue(addon.description);
    dialogRef.componentInstance.form.get('price').setValue(addon.price);
    dialogRef.componentInstance.form.get('isActive').setValue(addon.isActive);
    dialogRef.componentInstance.form.get('id').setValue(addon.id);

    dialogRef.afterClosed().subscribe(result => {
      if(result === 'save'){
        this.getAddons();
      }
    });
  }

  delete(addon: Addon){

    const dialogRef = this.dialog.open(AlertModalComponent);
    dialogRef.componentInstance.title = 'Delete Addon';
    dialogRef.componentInstance.body = `<h3 class="text-danger mat-h3">WARNING! THIS ACTION CANNOT BE UNDONE</h3> <br /> Are you sure you want to delete Addon <strong>${addon.name}</strong>?`;
    dialogRef.componentInstance.submitText = 'Yes';
    dialogRef.componentInstance.otherText = 'No';
    dialogRef.componentInstance.isOtherTextDisabled = false;
    dialogRef.afterClosed().subscribe((response) => {
      if(response === 'Yes'){
        this.isLoading = true;
        let data = {
          id: addon.id,
          lastEditedBy: this.sessionService.getUserId()
        };
        this.addonService.delete(data).subscribe({
          next: () => {
            this.getAddons();
          },
          error: (error) => {
            this.isLoading = false;
            console.error(error);
          },
          complete: () => this.isLoading = false
        });
      }
    });

  }

  sortData(sort: Sort) {
    this.filter.sortDirection = sort.direction;
    this.filter.sortColumn = sort.active;
    this.getAddons();
  }

  resetFilter() {
    this.filter.page = 1;
    this.filter.text = '';
    this.filter.pageSize = 15;
  }
}